import { Component, OnInit, ViewChild } from '@angular/core'
import { CpmService } from '../../../../service/cpm.service'
import { StoreService } from '../../../../service/store.service'
import { ActivatedRoute } from '@angular/router'
import { environment } from '../../../../../environments/environment'
import { TradingCompareToPeerComponent } from '../../../trading-compare-to-peer/trading-compare-to-peer.component'
import { PdfChart } from '../../../../shared/pdfChart'
import { PricePerformanceComponent } from '../../../price-performance/price-performance.component'
@Component({
  selector: 'app-full-fact-sheet-page-1-screen',
  templateUrl: './full-fact-sheet-page-1-screen.component.html',
  styleUrls: ['./full-fact-sheet-page-1-screen.component.scss']
})
export class FullFactSheetPage1ScreenComponent implements OnInit {
  @ViewChild(TradingCompareToPeerComponent)
  tradingCompare: TradingCompareToPeerComponent
  @ViewChild(PricePerformanceComponent)
  pricePerformane: PricePerformanceComponent
  pdf = false
  print = false
  displayHeader = false
  printPage = false
  symbol
  period = 'YTD'
  isFullFactSheet = false
  constructor(
    private store: StoreService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params
    const { pdf, print } = this.activatedRoute.snapshot.data
    pdf === undefined ? (this.pdf = false) : (this.pdf = pdf)
    print === undefined ? (this.print = false) : (this.print = print)
    this.store.setPeriodInputBehavior('YTD')
    this.store.getSecurityProfileNewResultObservable().subscribe(response => {
      if (!response) {
        return
      }
      this.symbol = response['securitySymbol']
    })

    this.tradingCompare.ngOnInit()

    if (this.print || this.pdf) {
      this.displayHeader = true
      this.printPage = true
      this.isFullFactSheet = true
      this.pdf = true
    } else {
      this.displayHeader = false
      this.printPage = false
      this.isFullFactSheet = true
      this.pdf = false
    }
  }
  exportFunctions() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>()
    arrayOfFunctions.set('print', this.exportPrint(this.symbol, this.period))
    arrayOfFunctions.set('pdf', this.exportPdf(this.symbol, this.period))
    return arrayOfFunctions
  }
  exportPrint = function (symbol, period) {
    return function fullFlagSheetPrint() {
      const endcodeSymbol = encodeURIComponent(symbol)
      window.open(
        `/#/fullfactsheet/${endcodeSymbol}/${period}`,
        '_blank',
        'width=850px,height=1024px'
      )
    }
  }

  exportPdf = function (symbol, period) {
    const service = this.cpmService
    return function exportFullFactSheetPdf() {
      const endcodeSymbol = encodeURIComponent(symbol)
      service.downloadFile(
        `${
        environment.cpmBaseUrl
        }/pdf/fullfactsheet?symbol=${endcodeSymbol}&period=${period}`
      )
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/full-fact-sheet/full-fact-sheet-page-1/full-fact-sheet-page-1-screen/full-fact-sheet-page-1-screen.component.ts